import Provider from "./context/Provider";
import Consumer from "./context/Consumer";
export type { TypographyBaseSize } from './interface';


const Context = {
  Provider,
  Consumer
};
export default Context;
